/** External URL opened in Safari for extension setup instructions. */
export const SAFARI_EXTENSION_INSTALL_URL = "https://seyu.lovable.app/site/safari-extension";

/** Safari extension bundle IDs per build environment, used for native messaging. */
const SAFARI_EXTENSION_IDS: Record<string, string> = {
  production: "com.intenttechnologies.want.SafariExtension (R92GJ67XM3)",
  staging: "com.intenttechnologies.want.staging.SafariExtension (R92GJ67XM3)",
  development: "com.intenttechnologies.want.dev.SafariExtension (R92GJ67XM3)",
};

/** Resolved Safari extension ID for the current build. */
export const SAFARI_EXTENSION_ID = SAFARI_EXTENSION_IDS[import.meta.env.MODE] ?? SAFARI_EXTENSION_IDS.development;

export const ALL_SAFARI_EXTENSION_IDS = Object.values(SAFARI_EXTENSION_IDS);
